import { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";
import { API, resolveContent } from "@/lib/cms";

const ContentContext = createContext(null);

export const useContent = () => useContext(ContentContext);

export const ContentProvider = ({ children }) => {
  const [content, setContent] = useState(null);

  useEffect(() => {
    axios.get(`${API}/content`)
      .then((r) => setContent(resolveContent(r.data)))
      .catch(() => setContent(null));
  }, []);

  if (!content) {
    return (
      <div className="min-h-screen bg-ink flex items-center justify-center">
        <span className="font-serif text-2xl text-cream/60 tracking-widest animate-pulse">Ghajoyan Photo</span>
      </div>
    );
  }

  return <ContentContext.Provider value={content}>{children}</ContentContext.Provider>;
};
